import * as i0 from "@angular/core";
export class RedirectGuard {
    constructor() { }
    canActivate(route, state) {
        window.location.href = route.data['externalUrl'];
        return true;
    }
}
RedirectGuard.ngInjectableDef = i0.defineInjectable({ factory: function RedirectGuard_Factory() { return new RedirectGuard(); }, token: RedirectGuard, providedIn: "root" });
